import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { ARTICLES } from "@/data/articles";

const Insights = () => (
  <section id="insights" data-testid="insights-section" className="px-6 md:px-12 py-24 md:py-36 border-t border-line">
    <div className="mx-auto max-w-[100rem]">
      <SectionHead
        index="06"
        label="The Insights Journal"
        title={<>Thinking that <em className="text-taupe">moves markets.</em></>}
      />
      <div>
        {ARTICLES.map((a, i) => (
          <Reveal key={a.slug} delay={i * 0.06}>
            <Link
              to={`/insights/${a.slug}`}
              data-testid={`article-link-${a.slug}`}
              className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-10 border-t border-line py-10 md:py-14 items-baseline"
            >
              <span className="md:col-span-2 font-serif italic text-taupe text-xl">{a.number}.</span>
              <div className="md:col-span-8">
                <p className="text-[10px] uppercase tracking-[0.25em] text-ash mb-3">{a.category}</p>
                <h3 className="font-serif text-3xl md:text-4xl font-light tracking-tight leading-tight group-hover:text-taupe transition-colors duration-300">
                  {a.title}
                </h3>
                <p className="mt-4 text-sm md:text-base font-light text-ash leading-relaxed max-w-2xl">
                  {a.excerpt}
                </p>
              </div>
              <div className="md:col-span-2 flex md:justify-end">
                <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em]">
                  Read
                  <ArrowUpRight size={14} className="text-taupe transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                </span>
              </div>
            </Link>
          </Reveal>
        ))}
        <div className="border-t border-line" />
      </div>
    </div>
  </section>
);

export default Insights;
